import {
  Button,
  Card,
  CardContent,
  Chip,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

function ShopOrderItem({ shop }) {
  const navigate = useNavigate();

  const getOrderCount = (orderedProducts = []) => {
    const includedParentIds = new Set();
    const countedItems = [];

    orderedProducts.forEach((product) => {
      const parentDetails = product?.parent_product_details?.[0];
      const parentId = parentDetails?.id;

      if (parentId !== undefined && parentId !== null) {
        if (!includedParentIds.has(parentId)) {
          includedParentIds.add(parentId);
          countedItems.push(product);
        }
      } else {
        countedItems.push(product);
      }
    });

    return countedItems.length;
  };

  const orderCount = getOrderCount(shop?.order?.ordered_products);

  return (
    <Card sx={{ backgroundColor: "whitesmoke", m: 3 }}>
      <CardContent>
        <div
          className="media align-items-center"
          style={{ position: "relative" }}
        >
          {orderCount > 1 && (
            <Chip
              label={`Count: ${orderCount}`}
              color="success"
              style={{ position: "absolute", top: 8, right: 8 }}
            />
          )}
          <div className="w-icon imgWidth position-relative">
            <img
              style={{ width: "100%", borderRadius: 8 }}
              src={
                shop?.order?.ordered_products?.[0]?.product_details?.[0]
                  ?.images?.[0].app_product_image
              }
              alt="user avatar"
              className="customer-img"
            />
            <Typography variant="p" color="primary" className="order-label">
              Order ID: #{shop?.order_id}
            </Typography>
          </div>
          <div className="media-body ml-3 border-left-xs border-light-3">
            <Typography variant="h6" color="error" className="mb-0">
              {
                shop?.order?.ordered_products?.[0]?.product_details?.[0]
                  ?.product_name
              }
            </Typography>
            <Typography variant="body2">
              Weight:{" "}
              {`${shop?.order?.ordered_products?.[0]?.variation?.weight?.[0]?.weight_name} ${shop?.order?.ordered_products?.[0]?.variation?.weight?.[0]?.unit?.unit_name}`}
            </Typography>
            {shop?.order?.ordered_products?.[0]?.flavour?.flavour_name !==
              "Default" && (
              <Typography variant="body2">
                Flavour:{" "}
                {shop?.order?.ordered_products?.[0]?.flavour?.flavour_name}
              </Typography>
            )}
            <hr style={{ marginTop: "1em", marginBottom: "1em" }} />
          </div>
        </div>
        <Grid container justifyContent="space-around" alignItems="center">
          <Button
            variant="contained"
            color="info"
            onClick={() => navigate(`/view-shop-order/${shop?.shop_order_id}`)}
            className="cusBtn"
          >
            View Order
          </Button>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default ShopOrderItem;